module.exports = __webpack_public_path__ + "static/media/google-icon.6de84695.svg";